import RecoverPassword from "./RecoverPassword";
import './recoverPassword.scss';

export default RecoverPassword;